export const environment = {
    prod: false,
    bumper: {
        url: 'https://bumper.vic3.co',
        id: '',
        secret: '',
    }
};
